import { render, staticRenderFns } from "./OnlineAppointments.vue?vue&type=template&id=22e9a67b"
import script from "./OnlineAppointments.vue?vue&type=script&lang=js"
export * from "./OnlineAppointments.vue?vue&type=script&lang=js"
import style0 from "./OnlineAppointments.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports